// extracted by mini-css-extract-plugin
module.exports = {"card":"card___2z-at","top":"top___3VpNZ","title":"title___1FjpW","slectct":"slectct___1SXnn","content":"content___13wQR"};